var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup, Query, DataKind } from "@easyquery/core";
import { DataType, utils as dataUtils } from '@easydata/core';
import { domel } from '@easydata/ui';
import { ColumnsBar } from './columns_bar';
import { QueryPanel } from './query_panel';
import { eqCssPrefix } from '../utils/utils';
var ManageDrillDownWidget = /** @class */ (function (_super) {
    __extends(ManageDrillDownWidget, _super);
    function ManageDrillDownWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.clickHandler = function () { return _this.openDialog(); };
        _this.columnsBar = null;
        _this.queryPanel = null;
        _this.ddQuery = null;
        _this.cssPrefix = eqCssPrefix;
        _this.group = WidgetGroup.None;
        return _this;
    }
    ManageDrillDownWidget.prototype.getWidgetType = function () {
        return 'manageDrillDown';
    };
    ManageDrillDownWidget.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.options = options;
        this.refresh();
        this.slot.addEventListener('click', this.clickHandler);
    };
    ManageDrillDownWidget.prototype.destroyCore = function () {
        this.slot.removeEventListener('click', this.clickHandler);
    };
    ManageDrillDownWidget.prototype.openDialog = function () {
        var _this = this;
        var dialogService = this.context.getServices().getDialogService();
        var query = this.context.getQuery();
        var model = this.context.getModel();
        var dialogBody = domel('div')
            .addClass(this.cssPrefix + "-manage-drilldown")
            .addChildElement(this.renderColumnsBarBlock())
            .addChildElement(this.renderQueryPanelBlock())
            .toDOM();
        var op = model.addOrUpdateOperator({
            id: 'BindToParentColumn',
            caption: 'is bound to',
            format: '{expr1} [[is bound to]] {expr2}',
            paramCount: 2,
            kind: DataKind.ParentColumn,
            appliedTypes: [DataType.String, DataType.Bool, DataType.Float, DataType.Int32, DataType.Int64, DataType.Word]
        });
        op.defaultOperand.dataType = DataType.String;
        op.defaultOperand.kind = DataKind.ParentColumn;
        model.runThroughEntities(function (attr) {
            var opIdx = attr.operators.indexOf(op.id);
            if (opIdx > 0) {
                dataUtils.moveArrayItem(attr.operators, opIdx, 0);
            }
        }, null);
        this.ddQuery = new Query(model, null, {
            parent: query
        });
        var dds = this.context.getQuery().getDrillDowns();
        if (dds.length) {
            var dd = dds[0];
            this.ddQuery.loadFromData(dd.toJSONData());
        }
        dialogService.open({
            title: 'Manage Drill Down',
            body: dialogBody,
            cancelable: true,
            closable: false,
            beforeOpen: function () {
                var columnsBarSlot = dialogBody.getElementsByClassName(_this.cssPrefix + "-columnsbar-slot")[0];
                _this.columnsBar = new ColumnsBar(columnsBarSlot, _this.ddQuery);
                _this.columnsBar.init(_this.context, _this.options.columnsBar);
                var queryPanelSlot = dialogBody.getElementsByClassName(_this.cssPrefix + "-querypanel-slot")[0];
                _this.queryPanel = new QueryPanel(queryPanelSlot, _this.ddQuery);
                _this.queryPanel.init(_this.context, _this.options.queryPanel);
                _this.columnsBar.refresh();
                _this.queryPanel.refresh();
            },
            onSubmit: function () {
                return _this.submitDialog();
            },
            onDestroy: function () {
                _this.destroyDialog();
            }
        });
    };
    ManageDrillDownWidget.prototype.renderQueryPanelBlock = function () {
        var _this = this;
        return domel('div')
            .addClass(this.cssPrefix + "-querypanel-block")
            .addChild('div', function (b) { return b
            .addClass(_this.cssPrefix + "-querypanel-caption"); })
            .addChild('div', function (b) { return b
            .addClass(_this.cssPrefix + "-querypanel-slot"); })
            .toDOM();
    };
    ManageDrillDownWidget.prototype.renderColumnsBarBlock = function () {
        var _this = this;
        return domel('div')
            .addClass(this.cssPrefix + "-columnsbar-block")
            .addChild('div', function (b) { return b
            .addClass(_this.cssPrefix + "-columnsbar-caption"); })
            .addChild('div', function (b) { return b
            .addClass(_this.cssPrefix + "-columnsbar-slot"); })
            .toDOM();
    };
    ManageDrillDownWidget.prototype.submitDialog = function () {
        if (this.ddQuery.tryValidate({
            checkExpressions: true
        })) {
            var dds = this.context.getQuery().getDrillDowns();
            if (dds.length) {
                dds[0].loadFromData(this.ddQuery.toJSONData());
                this.context.getQuery().fireChangedEvent();
            }
            else {
                if (!this.ddQuery.isEmpty()) {
                    var dd = this.context.getQuery().addDrillDown();
                    dd.loadFromData(this.ddQuery.toJSONData());
                    this.context.getQuery().fireChangedEvent();
                }
            }
            return true;
        }
        return false;
    };
    ManageDrillDownWidget.prototype.destroyDialog = function () {
        var model = this.context.getModel();
        model.removeOperator('BindToParentColumn', true);
        this.ddQuery = null;
        this.columnsBar && this.columnsBar.destroy();
        this.columnsBar = null;
        this.queryPanel && this.queryPanel.destroy();
        this.queryPanel = null;
    };
    return ManageDrillDownWidget;
}(Widget));
export { ManageDrillDownWidget };
//# sourceMappingURL=manage_drilldown_widget.js.map